import { create } from "zustand";

const useAuthStore = create((set) => ({
  email: localStorage.getItem("email") || "", // Get email from localStorage if available
  accessToken: localStorage.getItem("accessToken") || "", // Get access token from localStorage if available
  setAuth: ({ email, accessToken }) => {
    // Set the email and access token in the state and localStorage
    localStorage.setItem("email", email);
    localStorage.setItem("accessToken", accessToken);
    set({ email, accessToken });
  },
  clearAuth: () => {
    // Remove the email and access token from localStorage
    localStorage.removeItem("email");
    localStorage.removeItem("accessToken");
    set({ email: "", accessToken: "" });
  },
}));

export default useAuthStore;
